import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SettingsWholesalerOverview } from '../../../_models/admin/settings/settings.wholesaler.overview';
import { AdminSettingsService } from '../../../_services/admin/admin-settings.service';
import { ApiService } from 'app/_services/api.service';
import { AdminService } from 'app/_services/admin/admin.service';
import { SettingsBase } from 'app/_models/admin/settings/settings.base';
import { WholesalerInfo } from 'app/_models/admin/settings/wholesaler.info';

@Component({
  selector: 'app-admin-wholesaler-overview',
  templateUrl: './admin-wholesaler-overview.component.html',
  styleUrls: ['./admin-wholesaler-overview.component.scss']
})
export class AdminWholesalerOverviewComponent implements OnInit {
  settings: SettingsWholesalerOverview;
  filterString: string;
  invertFilter = false;
  infosBusy = false;
  supplierTagsBusy = false;

  constructor(
    public adminSettingsService: AdminSettingsService,
    private adminService: AdminService,
    private apiService: ApiService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: any) => {
        this.settings = data.settings;

        setTimeout(() => {

          this.supplierTagsBusy = true;
          this.apiService.adminGetSettingsWholesalerSupplierInterfaceOverview(this.adminService.currentUid, this.settings.Timing)
            .subscribe((settings: SettingsBase) => {
              const s = settings as SettingsWholesalerOverview;
              this.settings.Timing = s.Timing;
              s.WholesalerInfos.forEach(infoTag => {
                this.settings?.WholesalerInfos.forEach(info => {
                  if (infoTag.ID === info.ID) {
                    info.SupplierInterfacesTags = infoTag.SupplierInterfacesTags;
                  }
                });
              });
              this.supplierTagsBusy = false;
            });

          this.infosBusy = true;
          this.apiService.adminGetSettingsWholesalerOverview(this.adminService.currentUid, this.settings.Timing, true)
            .subscribe((settings: SettingsBase) => {
              const s = settings as SettingsWholesalerOverview;
              this.settings.Timing = s.Timing;
              s.WholesalerInfos.forEach(infoNew => {
                this.settings?.WholesalerInfos.forEach(info => {
                  if (infoNew.ID === info.ID) {
                    info.ShopPortalBackendApi = infoNew.ShopPortalBackendApi;
                    info.LegacyEasyCloudProvider = infoNew.LegacyEasyCloudProvider;
                    info.EasyCloudProviderApi = infoNew.EasyCloudProviderApi;
                    info.CloudProviderBackend = infoNew.CloudProviderBackend;
                  }
                });
              });
              this.infosBusy = false;
            });

        }, 100);

      });
  }

  getLatestVersionDate(backendInfo: string): Date {
    let latest = new Date(0);
    if (this.settings?.WholesalerInfos) {
      this.settings.WholesalerInfos.forEach(info => {
        if (info[backendInfo]) {
          info[backendInfo].forEach(bi => {
            if (bi.VersionDate > latest) latest = bi.VersionDate;
          });
        }
      });
    }
    return latest;
  }

  getLatestVersion(backendInfo: string): string {
    let latest = '';
    if (this.settings?.WholesalerInfos) {
      this.settings.WholesalerInfos.forEach(info => {
        if (info[backendInfo]) {
          info[backendInfo].forEach(bi => {
            if (bi.Version > latest) latest = bi.Version;
          });
        }
      });
    }
    return latest;
  }

  getSupplierInterfaceTags(supplierInterfacesTags: { [key: string]: { [key: string]: string[] } }): { tag: string, theme: string, data: string[] }[] {
    const tags: { tag: string, theme: string, data: string[] }[] = [];
    if (supplierInterfacesTags) {
      for (const [key, value] of Object.entries(supplierInterfacesTags)) {
        for (const [subKey, subValue] of Object.entries(value)) {
          tags.push({ tag: key, theme: subKey, data: subValue });
        }
      }
    }
    return tags;
  }

}
